module.exports = __webpack_public_path__ + "img/linkedin-box.edb746d0.svg";